/////////////////////////////////////////////////V5CommentStart
// myLocationInfo march1
// Mar14, more docs
// mar21 some debugging
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd import React from 'react'
import React from 'react'
import ReactDOM from 'react-dom'
import {
  Grid,
  Row,
  Col,
  Pagination,
  Pager,
  Button,
  Panel,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import queryString from 'query-string'
import classNames from 'classnames'

import SearchAreaForm from '../SearchAreaForm'
import InventoryFilter from './InventoryFilter'

import Dealers from './Dealers'
import Inventory from './Inventory'
import Sort from './Sort'
import Sentinel from '../Sentinel'

import {
  getInventoryItemsByVin,
  getDealers,
  getInventory,
  getFeaturedInventory,
} from '../../utils/rest'

import './DataView.css'

//---------------------------------------
//
//---------------------------------------
class PagerControl extends React.Component {
  //---------------------------------------
  //
  //---------------------------------------
  handleItemsPerPageChange = event => {
    const { value } = event.target
    const ipp = parseInt(value, 10)

    const offset = (this.props.activePage - 1) * this.props.ipp
    const page = Math.floor(offset / ipp) + 1

    this.props.onItemsPerPageChange({ page, ipp })
  }

  //---------------------------------------
  //
  //---------------------------------------
  handleSelect = page => {
    this.props.onPageChange(page)
  }

  //---------------------------------------
  //
  //---------------------------------------
  previous = () => {
    const { activePage } = this.props
    if (activePage > 1) {
      this.handleSelect(activePage - 1)
    }
  }

  //---------------------------------------
  //
  //---------------------------------------
  next = items => {
    const { activePage } = this.props
    if (activePage < items) {
      this.handleSelect(activePage + 1)
    }
  }

  //---------------------------------------
  //
  //---------------------------------------
  render() {
    console.log(`CFD_FUNC_DATAVIEW_renderPAGERCONTROL:`)
    const paginationSettings = {
      prev: true,
      next: true,
      first: true,
      last: true,
      ellipsis: true,
      boundaryLinks: true,
      items: this.props.items,
      maxButtons: 5,
      activePage: this.props.activePage || 1,
      onSelect: this.handleSelect,
    }

    //---------------------------------------
    //
    //---------------------------------------
    return (
      !this.props.detail && (
        <React.Fragment>
          <Row className="pager">
            <Pager>
              <Pager.Item
                href="#"
                onSelect={e => this.previous()}
                disabled={this.props.activePage === 1}
              >
                Previous
              </Pager.Item>{' '}
              <Pager.Item
                href="#"
                onSelect={e => this.next(this.props.items)}
                disabled={this.props.activePage >= this.props.items}
              >
                Next
              </Pager.Item>
            </Pager>
          </Row>
          <Row>
            <Col
              className="pagination-centered"
              xsOffset={0}
              xs={9}
              smOffset={2}
              sm={8}
            >
              <Pagination
                className="visible-lg visible-md"
                bsSize="large"
                {...paginationSettings}
              />
              <Pagination
                className="visible-sm"
                bsSize="medium"
                {...paginationSettings}
              />
              <Pagination
                className="visible-xs"
                bsSize="small"
                {...paginationSettings}
              />
            </Col>
            <Col xs={3} sm={2}>
              <Form
                id="DataView-select-items-per-page"
                style={{ display: 'inline-block', margin: '0 0 20px 0' }}
              >
                <FormGroup controlId={'DataView-select-items-per-page-control'}>
                  <ControlLabel>Items</ControlLabel>
                  <FormControl
                    name="ipp"
                    componentClass="select"
                    value={this.props.ipp}
                    style={{ padding: 0 }}
                    onChange={this.handleItemsPerPageChange}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                  </FormControl>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </React.Fragment>
      ) // close if
    ) // close return
  } // end render function
} // end class pager Control

//---------------------------------------
// Status of result set varies on functions
//---------------------------------------
class Status extends React.Component {
  render() {
    console.log(`CFD_FUNC_DATAVIEW_renderSTATUS:`)
    let resultStatus = ''
    if (this.props.error) {
      resultStatus = <em>{this.props.error.toString()}</em>
    } else {
      const { itemCount, myLocationInfo } = this.props
      if (this.props.savedCars) {
        resultStatus =
          itemCount === 0 ? (
            <em>Your saved cars list is empty.</em>
          ) : (
            <em>
              You have {itemCount.toLocaleString()} car{itemCount > 1 && 's'} in
              your wish list
            </em>
          )
      } else {
        //DDFIX, wtf is this
        let searchDomain = ''
        let help = ''
        if (this.props.match.params.did) {
          const {
            dealer: { name = "the dealer's location" },
          } = this.props.location.state || { dealer: {} }
          searchDomain = `at ${name}`
          help = 'Try changing your search filter or try another dealer.'
        } else {
          // *************************************
          // Make the text descibing car count and mention distance
          // *************************************
          searchDomain =
            myLocationInfo.radius >= 25000
              ? 'nationwide'
              : myLocationInfo.radius > 0
              ? `within ${myLocationInfo.radius} mile${
                  myLocationInfo.radius === 1 ? '' : 's'
                } of `
              : 'in '

          searchDomain +=
            myLocationInfo.radius >= 25000
              ? ''
              : myLocationInfo.address || myLocationInfo.zipCode

          help =
            this.props.type === 'inventory'
              ? myLocationInfo.radius >= 2500
                ? 'Try changing your search filter.'
                : 'Try changing your search filter or expand your search area.'
              : myLocationInfo.radius >= 2500
              ? null
              : 'Try changing your search filter.'
        }

        resultStatus =
          itemCount === 0 ? (
            <em>
              We couldn't find any{' '}
              {this.props.type === 'inventory'
                ? `${this.props.search.cond} cars matching your filter`
                : 'dealers'}{' '}
              {searchDomain}.
              <br />
              {help}
            </em>
          ) : (
            <em>
              We found {itemCount.toLocaleString()}{' '}
              {this.props.type !== 'dealers' && this.props.search.cond}{' '}
              {this.props.type === 'dealers' ? 'dealers' : 'cars'}{' '}
              {searchDomain}
            </em>
          )
      }
    }

    return (
      <Row className={classNames('Status', this.props.error && 'error')}>
        <Col xs={12} className="status">
          {resultStatus}
        </Col>
      </Row>
    )
  }
} // end class Status

//---------------------------------------
//
//---------------------------------------
class DataViewWithControls extends React.Component {
  state = {
    activePage: this.props.detail
      ? 1
      : parseInt(this.props.search.page, 10) || 1,
    ipp: this.props.detail ? 1 : parseInt(this.props.search.ipp, 10) || 1,
  }

  handlePageChange = page => {
    const search = '?' + queryString.stringify({ ...this.props.search, page })
    const { location } = this.props
    this.props.history.push({ ...location, search })
  }

  handleItemsPerPageChange = ({ ipp, page }) => {
    const search =
      '?' + queryString.stringify({ ...this.props.search, page, ipp })
    const { location } = this.props
    // navigate to page
    this.props.history.push({ ...location, search })
  }

  submitOpenForm = () => {
    let form = null
    if (this.state.openInventoryFilterPanel) {
      form = this.inventoryFilterRef
    } else if (this.state.openSearchAreaPanel) {
      form = this.searchAreaRef
    }
    if (form) {
      form = ReactDOM.findDOMNode(form)
      if (form.tagName !== 'FORM') {
        form = form.querySelector('form')
      }
      const button = form.querySelector('button[type=submit]')
      if (!button.disabled) {
        button.click()
      }
    }
  }

  render() {
    console.log(`CFD_FUNC_DATAVIEW_renderDataviewwithcontrols:`)
    const { component: Component, ...props } = this.props

    const classes = classNames(
      'DataView',
      this.props.type,
      this.props.detail ? 'detail-view' : 'grid-view'
    )

    const itemCount = parseInt(this.props.itemCount, 10)
    const ipp = this.state.ipp
    const items =
      itemCount === 0 ? itemCount : Math.floor((itemCount + ipp - 1) / ipp)

    let myLocationInfo = {
      ...this.props.search,
      ...this.props.app.state.myLocationInfo,
      ...this.props.app.searchAreaSupplemental,
    }

    const displayInventoryFilter =
      this.props.type === 'inventory' &&
      !(this.props.detail || this.props.savedCars)

    const filterButton = displayInventoryFilter && (
      <Button
        onClick={() => {
          this.submitOpenForm()
          this.setState(state => ({
            openInventoryFilterPanel: !this.state.openInventoryFilterPanel,
            openSearchAreaPanel: false,
          }))
        }}
      >
        <FontAwesome name="filter" /> Filter Results
      </Button>
    )

    const searchAreaButton = !this.props.detail &&
      !this.props.did &&
      !this.props.savedCars && (
        <Button
          onClick={() => {
            this.submitOpenForm()
            this.setState(state => ({
              openInventoryFilterPanel: false,
              openSearchAreaPanel: !this.state.openSearchAreaPanel,
            }))
          }}
        >
          <FontAwesome name="compass" /> Change Search Area
        </Button>
      )

    const sortButton = displayInventoryFilter && (
      <Sort className="btn" {...this.props} />
    )

    return (
      <Grid className={classes}>
        {(this.props.error || !this.props.detail) && (
          <Sentinel silent>
            <Status
              {...this.props}
              itemCount={itemCount}
              myLocationInfo={myLocationInfo}
            />
          </Sentinel>
        )}
        <Row className="filters">
          <Col xs={12}>
            {searchAreaButton} {filterButton} {sortButton}
          </Col>
          {!this.props.detail && !this.props.savedCars && (
            <Col xs={12} className="filters">
              {displayInventoryFilter && (
                <Panel
                  collapsible
                  expanded={this.state.openInventoryFilterPanel}
                  className="filter-panel"
                >
                  <InventoryFilter
                    search={this.props.search}
                    location={this.props.location}
                    history={this.props.history}
                    ref={_ => (this.inventoryFilterRef = _)}
                  />
                </Panel>
              )}
              <Panel
                collapsible
                expanded={this.state.openSearchAreaPanel}
                className="searh-area-panel"
              >
                <Col lg={3} md={4} sm={6}>
                  <SearchAreaForm
                    search={this.props.search}
                    location={this.props.location}
                    history={this.props.history}
                    app={this.props.app}
                    id="change-zip-code-prompt"
                    ref={_ => (this.searchAreaRef = _)}
                  />
                </Col>
              </Panel>
            </Col>
          )}
        </Row>
        <Row className="item-grid">
          {!this.props.error && (
            <Sentinel>
              <Component {...props} />
            </Sentinel>
          )}
        </Row>
        {!this.props.error && !this.props.detail && (
          <PagerControl
            onItemsPerPageChange={this.handleItemsPerPageChange}
            onPageChange={this.handlePageChange}
            ipp={ipp}
            items={items}
            activePage={this.state.activePage}
          />
        )}
      </Grid>
    )
  }
} // end class DataViewWithControls

//---------------------------------------
//
//---------------------------------------
class DataViewer extends React.Component {
  constructor(props) {
    console.log(`CFD_FUNC_DATAVIEW_constructorDataViewer:`)
    super(props)
    this.state = {
      items: null,
      itemCount: null,
      error: null,
    }
  }

  componentWillReceiveProps(props) {
    console.log(`CFD_FUNC_DATAVIEW_componentWillReceiveProps0:`)
    if (this.props.location !== props.location) {
      console.log(`CFD_FUNC_DATAVIEW_componentWillReceiveProps1: is TRUE`)
      console.log(
        `CFD_FUNC_DATAVIEW_componentWillReceiveProps1a: ` + this.props.location
      )
      console.log(
        `CFD_FUNC_DATAVIEW_componentWillReceiveProps1b: ` + props.location
      )

      this.reload = true
    } else {
      console.log(`CFD_FUNC_DATAVIEW_componentWillReceiveProps1: is FALSE`)
      console.log(
        `CFD_FUNC_DATAVIEW_componentWillReceiveProps2a: ` + this.props.location
      )
    }
  }

  componentDidUpdate() {
    console.log(`CFD_FUNC_DATAVIEW_componentDidupdateDataViewer:`)
    if (this.reload) {
      this.loader()
      this.reload = false
    }
  }

  componentDidMount() {
    console.log(`CFD_FUNC_DATAVIEW_componentDidmountDataviewer:`)
    this.loader()
  }

  loader = () => {
    const that = this
    const { load, ...props } = this.props

    load(props)
      .then(result => {
        return { error: null, ...result }
      })
      .catch(err => {
        return {
          error:
            'Server Error. Please try again.Report as Error:122: ' +
            err.message,
          result: null,
        }
      })
      .then(result => that.setState(result))
  }

  render() {
    // Show spinner while loading
    return this.state.error || (this.state.items && !this.reload) ? (
      <Sentinel>
        
        <DataViewWithControls {...this.props} {...this.state} />
      </Sentinel>
    ) : (
      <div style={{ minHeight: `${window.innerHeight}px` }}>
        <FontAwesome className="fa-spin fa-3x fa-fw" name="cog" />
      </div>
    )
  }
} // end class DataViewer

const DataView = {}
export default DataView

//---------------------------------------
//
//---------------------------------------
DataView.Inventory = class extends React.Component {
  render() {
    //DDFIX, this needs setitem adjustments
    console.log(`CFD_FUNC_DATAVIEW_InventoryRenderWANDAx`, this.props)
    if (this.props.app.redirect) return null
    let search = queryString.parse(this.props.location.search)
    const { did } = this.props.match.params
    console.log(
      `CFD_FUNC_DATAVIEW_InventoryRenderMYMORNINGJACKET:` + this.props.app.state
    )
    console.log(
      `CFD_FUNC_DATAVIEW_InventoryRenderMYMORNINGJACKET2:` +
        this.props.app.state
    )
    var tempstate = JSON.parse(localStorage.getItem('state'))
    tempstate.myBasicParams.ipp = search.ipp

    //  DDFIX... WHAT DOES THIS  ACCOMPLISH?
    if (!('radius' in search)) {
      search.radius = 25000
    }

    const component = Inventory
    const props = { ...this.props, component, search, did, load: getInventory }

    console.log(`CFD_FUNC_DATAVIEW_InventoryRenderJaneFonda` + props)
    return <DataViewer type="inventory" list {...props} />
  }
}

//---------------------------------------
//
//---------------------------------------
DataView.Inventory.Detail = class extends React.Component {
  render() {
    if (this.props.app.redirect) return null
    const component = Inventory
    const { vin } = this.props.match.params
    const props = { ...this.props, component, vin, load: getInventory }

    return <DataViewer type="inventory" detail {...props} />
  }
}

//---------------------------------------
//
//---------------------------------------
DataView.Inventory.Saved = class extends React.Component {
  load = props => {
    const savedCars = props.app.getSavedCars()
    const { page, ipp } = this.props.app.search
    const offset = (page - 1) * ipp
    const items = savedCars.slice(offset, offset + ipp)

    return getInventoryItemsByVin(items).then(results => {
      const items = results
        .filter(result => result !== null)
        .map(result => result.items[0])
      return { items, itemCount: savedCars.length }
    })
  }

  render() {
    if (this.props.app.redirect) return null
    const search = queryString.parse(this.props.location.search)
    //GOODFRIDAY
    //localStorage.setItem('ipp', search.ipp)
    var tempstate = JSON.parse(localStorage.getItem('state'))
    tempstate.myBasicParams.ipp = search.ipp
    localStorage.setItem('state', JSON.stringify(tempstate))

    const component = Inventory
    const props = { ...this.props, component, search, load: this.load }
    return <DataViewer type="inventory" list savedCars {...props} />
  }
}

//---------------------------------------
//
//---------------------------------------
DataView.Inventory.Featured = class extends React.Component {
  constructor(props) {
    console.log(`CFD_FUNC_DATAVIEW_DataView.Inventory.Featured_construct: `)
    super(props)
    this.state = {
      items: null,
      itemCount: null,
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.location !== props.location) {
      this.reload = true
    }
  }

  componentDidUpdate() {
    console.log(
      `CFD_FUNC_DATAVIEW_DataView.Inventory.FeaturedcomponentdidUpdate`
    )
    if (this.reload) {
      this.loader()
      this.reload = false
    }
  }

  componentDidMount() {
    console.log(
      `CFD_FUNC_DATAVIEW_DataView.Inventory.FeaturedcomponentdidMount`
    )
    this.loader()
  }

  loader = () => {
    const search = this.props.search
    const { vin } = this.props.match.params
    const props = { ...this.props, vin, search }
    const that = this
    getFeaturedInventory(props)
      .then(result => {
        return { error: null, ...result }
      })
      .catch(err => {
        console.error(
          `DataView.Inventory.Featured getFeaturedInventory()222`,
          vin,
          search
        )
      })
      .then(result => that.setState(result))
  }

  render() {
    if (this.state.items === null) return null
    return (
      <Sentinel silent>
        <Inventory type="inventory" featured {...this.props} {...this.state} />
      </Sentinel>
    )
  }
}

//---------------------------------------
//
//---------------------------------------
DataView.Dealers = class extends React.Component {
  render() {
    // DDFIX, this needs setitem Fixes

    if (this.props.app.redirect) return null
    let search = queryString.parse(this.props.location.search)

    var tempstate = JSON.parse(localStorage.getItem('state'))
    if (!('radius' in search)) {
      search.radius = 25000
    }
    tempstate.myBasicParams.ipp = search.ipp
    tempstate.myBasicParams.radius = search.radius
    localStorage.setItem('state', JSON.stringify(tempstate))

    const component = Dealers
    const props = { ...this.props, component, search, load: getDealers }
    return <DataViewer type="dealers" list {...props} />
  }
}

//---------------------------------------
//
//---------------------------------------
DataView.Dealers.Detail = class extends React.Component {
  render() {
    if (this.props.app.redirect) return null
    const component = Dealers
    const { did } = this.props.match.params
    const props = { ...this.props, component, load: getDealers, did }
    return <DataViewer type="dealers" detail {...props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/DataView.js